<template>
  <div>
    <el-select
      :value="value"
      :class="className"
      size="small"
      :clearable="search"
      @change="handleChange"
      placeholder="请选择"
      style="width: 100%"
      :popper-append-to-body="false"
    >
      <el-option
        :key="0"
        :label="search ? '不限' : '请选择'"
        :value="0"
        :disabled="!search"
      ></el-option>
      <el-option
        v-for="(v, k) in lists"
        :key="k"
        :label="v"
        :value="parseInt(k)"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
import { fixBaseList } from '../../service/getData'

export default {
  props: {
    value: '',
    className: '',
    search: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lists: [],
    }
  },
  created() {
    this.requestData()
  },
  methods: {
    handleChange(e) {
      this.$emit('input', e)
    },

    async requestData() {
      let res = await fixBaseList()
      this.lists = res.data
    },
  },
}
</script>